export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  imageUrl: string;
}

export const categories = [
  { name: '全部文章', slug: 'all' },
  { name: '下载安装', slug: 'download-install' },
  { name: '使用技巧', slug: 'usage-tips' },
  { name: '隐私安全', slug: 'privacy-security' },
  { name: '常见问题', slug: 'faq' },
  { name: '版本更新', slug: 'version-updates' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '91浏览器最新版本下载与安装完整教程',
    slug: 'latest-version-download-install-guide',
    category: '下载安装',
    categorySlug: 'download-install',
    excerpt: '详细介绍91浏览器最新版本的下载方式、安装步骤及首次使用设置，覆盖Android和iOS双平台，帮助用户快速完成安装并开始安全浏览。',
    content: `<h2>91浏览器下载渠道</h2><p>91浏览器目前支持通过以下官方渠道下载：</p><h3>Android用户</h3><p>Android用户可以通过官方应用商店（如华为应用市场、小米应用商店、OPPO软件商店、vivo应用商店等）搜索"91浏览器"进行下载。也可以通过官方网站直接下载APK安装包。</p><h3>iOS用户</h3><p>iOS用户可以在App Store中搜索"91浏览器"进行下载安装。</p><h2>安装步骤</h2><p>1. 打开应用商店，搜索"91浏览器"；</p><p>2. 点击"下载"或"获取"按钮；</p><p>3. 等待下载完成后，系统将自动安装；</p><p>4. 安装完成后，点击桌面图标即可打开91浏览器。</p><h2>首次使用设置</h2><p>首次打开91浏览器时，系统会引导您完成基础设置，包括选择默认搜索引擎、设置隐私偏好、导入书签等。建议用户根据个人需求完成这些设置，以获得最佳浏览体验。</p>`,
    author: '91浏览器官方团队',
    date: '2026-08-01',
    readTime: '5分钟',
    tags: ['下载', '安装', '教程', '新手指南'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20clean%20browser%20interface%20on%20a%20minimalist%20white%20desk%20with%20soft%20natural%20lighting%2C%20digital%20lifestyle%20product%20photography%2C%20clean%20composition%2C%20warm%20white%20background%2C%20high%20detail&width=600&height=400&seq=article-1&orientation=landscape',
  },
  {
    id: '2',
    title: '91浏览器隐私保护功能全面解析',
    slug: 'privacy-protection-features-guide',
    category: '隐私安全',
    categorySlug: 'privacy-security',
    excerpt: '深入了解91浏览器的隐私保护体系，包括无痕浏览模式、广告拦截、追踪防护、指纹保护等核心隐私功能，让您的上网行为得到全方位保护。',
    content: `<h2>隐私保护核心理念</h2><p>91浏览器将用户隐私放在首位，构建了多层次隐私保护体系，确保用户的上网数据安全无虞。</p><h2>无痕浏览模式</h2><p>开启无痕浏览后，91浏览器不会记录您的浏览历史、搜索记录、Cookie和表单数据。关闭无痕窗口后，所有浏览痕迹将被自动清除。</p><h2>广告拦截功能</h2><p>内置强大的广告拦截引擎，可有效屏蔽弹窗广告、视频广告、恶意广告等，提升页面加载速度的同时保护您的隐私。</p><h2>追踪防护</h2><p>91浏览器自动阻止第三方追踪器收集您的浏览数据，防止广告商和分析公司跨站点追踪您的行为。</p><h2>指纹保护</h2><p>通过浏览器指纹混淆技术，防止网站通过设备信息唯一识别和追踪用户，进一步增强匿名性。</p>`,
    author: '91浏览器安全团队',
    date: '2026-07-28',
    readTime: '6分钟',
    tags: ['隐私', '安全', '无痕浏览', '广告拦截'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20shield%20concept%20with%20soft%20glowing%20lines%20representing%20data%20protection%2C%20minimalist%20tech%20security%20visual%2C%20warm%20neutral%20background%20with%20subtle%20gradient%2C%20clean%20modern%20design&width=600&height=400&seq=article-2&orientation=landscape',
  },
  {
    id: '3',
    title: '多标签浏览：高效管理您的网页',
    slug: 'multi-tab-browsing-tips',
    category: '使用技巧',
    categorySlug: 'usage-tips',
    excerpt: '学会使用91浏览器的多标签管理功能，包括标签分组、快速切换、标签预览、批量操作等实用技巧，大幅提升您的浏览效率。',
    content: `<h2>多标签管理概述</h2><p>91浏览器的多标签管理系统让您可以同时打开数十个网页而不会感到混乱。以下是几个提升效率的技巧。</p><h2>标签分组</h2><p>您可以将相关标签拖放到一起创建标签组，为每个组命名并分配颜色标识。例如将工作相关网页放在一个组，娱乐内容放在另一个组。</p><h2>快速切换</h2><p>在标签栏左右滑动即可快速切换标签页，或使用标签缩略图视图一览所有打开的页面，点击即可跳转。</p><h2>批量操作</h2><p>长按标签可选择多个标签页，然后一键添加到书签、关闭或移动到新窗口。</p><h2>标签恢复</h2><p>不小心关闭了标签？91浏览器支持一键恢复最近关闭的标签页，最多可恢复20个。</p>`,
    author: '91浏览器产品团队',
    date: '2026-07-25',
    readTime: '4分钟',
    tags: ['多标签', '效率', '技巧', '标签管理'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20modern%20digital%20tablet%20displaying%20multiple%20browser%20tabs%20in%20an%20organized%20layout%2C%20productivity%20concept%2C%20minimalist%20workspace%20with%20warm%20lighting%2C%20soft%20shadows%2C%20aesthetic%20tech%20photography&width=600&height=400&seq=article-3&orientation=landscape',
  },
  {
    id: '4',
    title: '91浏览器阅读模式使用指南',
    slug: 'reading-mode-guide',
    category: '使用技巧',
    categorySlug: 'usage-tips',
    excerpt: '91浏览器的阅读模式可以去除网页中的广告和干扰元素，提供纯净的阅读体验。本文详细介绍阅读模式的开启方式、自定义设置和实用技巧。',
    content: `<h2>什么是阅读模式</h2><p>阅读模式是91浏览器的一项特色功能，可以自动识别网页正文内容，去除广告、导航栏、侧边栏等干扰元素，呈现干净清爽的阅读界面。</p><h2>如何开启阅读模式</h2><p>1. 打开任意文章页面；</p><p>2. 点击地址栏右侧的"阅读模式"图标（书本形状）；</p><p>3. 页面将自动切换到阅读模式。</p><h2>自定义设置</h2><p>在阅读模式下，您可以调整字体大小、背景颜色（白色/米色/深色）、行间距和字体样式，打造最适合自己的阅读环境。</p><h2>自动进入阅读模式</h2><p>您可以在设置中开启"自动进入阅读模式"，当检测到文章页面时，浏览器将自动切换为阅读模式。</p>`,
    author: '91浏览器产品团队',
    date: '2026-07-20',
    readTime: '4分钟',
    tags: ['阅读模式', '技巧', '自定义', '用户体验'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20e-reader%20style%20display%20showing%20clean%20typography%20on%20a%20warm%20paper%20texture%20background%2C%20reading%20mode%20concept%2C%20minimalist%20digital%20reading%20device%2C%20soft%20warm%20light%2C%20cozy%20atmosphere&width=600&height=400&seq=article-4&orientation=landscape',
  },
  {
    id: '5',
    title: '91浏览器数据同步功能详解',
    slug: 'data-sync-feature-guide',
    category: '使用技巧',
    categorySlug: 'usage-tips',
    excerpt: '了解如何使用91浏览器的数据同步功能，在手机、平板等多设备间同步书签、历史记录、密码等数据，实现无缝浏览体验。',
    content: `<h2>数据同步简介</h2><p>91浏览器支持跨设备数据同步，只需登录同一账号，即可在手机、平板等设备间无缝同步您的浏览数据。</p><h2>可同步的数据类型</h2><p>支持同步书签、浏览历史、保存的密码、打开的标签页、个人设置等。</p><h2>如何开启同步</h2><p>1. 打开91浏览器，进入"设置"；</p><p>2. 点击"账号与同步"；</p><p>3. 登录您的91账号（如无账号请先注册）；</p><p>4. 选择需要同步的数据类型；</p><p>5. 点击"开始同步"即可。</p><h2>同步安全</h2><p>所有同步数据均采用端到端加密传输，即使是91浏览器的服务器也无法解密您的数据，确保隐私安全。</p>`,
    author: '91浏览器技术团队',
    date: '2026-07-15',
    readTime: '5分钟',
    tags: ['同步', '多设备', '书签', '数据'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Multiple%20modern%20devices%20smartphone%20and%20tablet%20displaying%20synchronized%20content%20with%20flowing%20data%20visualization%2C%20device%20sync%20concept%2C%20clean%20minimalist%20studio%20setup%2C%20warm%20neutral%20tones&width=600&height=400&seq=article-5&orientation=landscape',
  },
  {
    id: '6',
    title: '91浏览器夜间模式设置与护眼技巧',
    slug: 'night-mode-eye-care-tips',
    category: '使用技巧',
    categorySlug: 'usage-tips',
    excerpt: '91浏览器的夜间模式可以有效减少蓝光对眼睛的伤害。本文介绍夜间模式的开启方式、定时设置以及配合系统深色模式使用的最佳实践。',
    content: `<h2>夜间模式的重要性</h2><p>长时间在暗光环境下使用手机浏览网页，屏幕蓝光会对眼睛造成伤害。91浏览器的夜间模式可以有效减少蓝光辐射，保护视力。</p><h2>手动开启夜间模式</h2><p>1. 打开91浏览器，点击底部菜单栏的"设置"图标；</p><p>2. 在设置页面找到"夜间模式"选项；</p><p>3. 点击开关即可开启。</p><h2>定时自动切换</h2><p>您可以设置夜间模式自动开启的时间段，例如晚上10点到早上7点自动切换，无需手动操作。</p><h2>跟随系统深色模式</h2><p>91浏览器支持跟随系统深色模式设置，当手机系统切换到深色模式时，浏览器也会自动切换。</p>`,
    author: '91浏览器产品团队',
    date: '2026-07-10',
    readTime: '3分钟',
    tags: ['夜间模式', '护眼', '深色模式', '健康'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20dark%20mode%20browser%20interface%20in%20a%20dimly%20lit%20room%2C%20eye%20comfort%20concept%2C%20warm%20ambient%20lighting%2C%20cozy%20nighttime%20scene%2C%20digital%20wellness%20photography&width=600&height=400&seq=article-6&orientation=landscape',
  },
  {
    id: '7',
    title: '91浏览器v8.0版本更新日志',
    slug: 'version-8-0-update-log',
    category: '版本更新',
    categorySlug: 'version-updates',
    excerpt: '91浏览器v8.0版本正式发布，带来全新UI设计、性能大幅提升、智能下载管理等重磅更新，全面优化您的浏览体验。',
    content: `<h2>v8.0版本亮点</h2><p>91浏览器v8.0版本经过数月的研发和测试，带来了多项重要更新。</p><h2>全新UI设计</h2><p>重新设计了界面风格，采用更简洁的图标和更流畅的动画效果，操作体验更加顺手。</p><h2>性能提升</h2><p>页面加载速度提升40%，内存占用降低25%，让低配手机也能流畅运行。</p><h2>智能下载管理</h2><p>全新的下载管理器支持断点续传、下载分类、批量管理等功能，视频下载速度提升60%。</p><h2>其他更新</h2><p>- 新增网页翻译功能，支持50+语言；</p><p>- 优化广告拦截规则，拦截率提升15%；</p><p>- 修复已知bug，提升稳定性。</p>`,
    author: '91浏览器开发团队',
    date: '2026-07-05',
    readTime: '3分钟',
    tags: ['版本更新', 'v8.0', '新功能', '性能'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20number%208%20design%20with%20gradient%20and%20glowing%20digital%20effects%2C%20version%20update%20concept%2C%20modern%20tech%20visual%20with%20warm%20coral%20and%20teal%20tones%2C%20clean%20dark%20background&width=600&height=400&seq=article-7&orientation=landscape',
  },
  {
    id: '8',
    title: '91浏览器常见问题汇总',
    slug: 'frequently-asked-questions',
    category: '常见问题',
    categorySlug: 'faq',
    excerpt: '收集了91浏览器用户最常遇到的问题及解决方案，涵盖下载安装、功能使用、性能优化、账号同步等多个方面。',
    content: `<h2>下载与安装</h2><h3>Q: 91浏览器支持哪些平台？</h3><p>A: 91浏览器目前支持Android 7.0及以上版本和iOS 13.0及以上版本。</p><h3>Q: 安装后无法打开怎么办？</h3><p>A: 请尝试卸载后重新安装最新版本，或检查手机系统版本是否符合要求。</p><h2>功能使用</h2><h3>Q: 如何设为默认浏览器？</h3><p>A: 进入手机设置 → 应用管理 → 默认应用 → 浏览器，选择91浏览器即可。</p><h3>Q: 如何清除浏览记录？</h3><p>A: 打开91浏览器 → 设置 → 隐私 → 清除浏览数据，选择需要清除的数据类型即可。</p><h2>性能优化</h2><h3>Q: 浏览器运行卡顿怎么办？</h3><p>A: 建议定期清理缓存数据，关闭不使用的标签页，或前往设置中开启"性能模式"。</p>`,
    author: '91浏览器客服团队',
    date: '2026-06-30',
    readTime: '5分钟',
    tags: ['常见问题', 'FAQ', '故障排除', '帮助'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20FAQ%20concept%20with%20question%20mark%20icons%20and%20clean%20cards%20arrangement%2C%20customer%20support%20visual%2C%20warm%20neutral%20background%20with%20soft%20shadows%2C%20modern%20help%20center%20design&width=600&height=400&seq=article-8&orientation=landscape',
  },
  {
    id: '9',
    title: '91浏览器Android版下载安装指南',
    slug: 'android-download-install-guide',
    category: '下载安装',
    categorySlug: 'download-install',
    excerpt: '专为Android用户打造的91浏览器下载安装详细教程，包含官方APK下载、各品牌手机安装注意事项以及首次配置建议。',
    content: `<h2>Android版简介</h2><p>91浏览器Android版针对Android系统深度优化，充分利用Android平台特性，提供流畅的浏览体验。</p><h2>下载方式</h2><p>方式一：打开手机自带应用商店（华为应用市场、小米应用商店等），搜索"91浏览器"下载。</p><p>方式二：访问91浏览器官方网站，下载最新版APK安装包。</p><h2>安装注意事项</h2><p>如果通过APK方式安装，需要在手机设置中开启"允许安装未知来源应用"权限。安装完成后建议关闭此权限以保障安全。</p><h2>首次配置</h2><p>安装完成后，建议完成以下设置：选择默认搜索引擎、开启广告拦截、设置隐私偏好、登录账号开启同步。</p>`,
    author: '91浏览器官方团队',
    date: '2026-06-25',
    readTime: '4分钟',
    tags: ['Android', '下载', '安装', 'APK'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Android%20smartphone%20displaying%20browser%20download%20screen%20on%20a%20clean%20white%20desk%20surface%2C%20app%20installation%20concept%2C%20minimalist%20product%20photography%2C%20warm%20natural%20light%2C%20professional%20composition&width=600&height=400&seq=article-9&orientation=landscape',
  },
  {
    id: '10',
    title: '91浏览器网页翻译功能使用技巧',
    slug: 'web-translation-tips',
    category: '使用技巧',
    categorySlug: 'usage-tips',
    excerpt: '91浏览器内置强大的网页翻译功能，支持50多种语言互译。学习如何高效使用翻译功能浏览外文网站，提升您的国际化信息获取能力。',
    content: `<h2>翻译功能简介</h2><p>91浏览器v8.0版本全新内置网页翻译功能，支持中、英、日、韩、法、德、西等50多种语言之间的互译。</p><h2>使用方式</h2><p>1. 打开任意外文网页；</p><p>2. 点击地址栏右侧的"翻译"图标；</p><p>3. 在弹出的菜单中选择目标语言；</p><p>4. 页面内容将自动翻译为目标语言。</p><h2>自动翻译设置</h2><p>您可以在设置中开启"自动翻译"，当检测到非母语网页时，浏览器将自动进行翻译，省去手动点击的步骤。</p><h2>翻译质量</h2><p>91浏览器采用先进的神经网络翻译引擎，翻译准确度高，语句通顺自然，尤其在科技、新闻类内容的翻译上表现优异。</p>`,
    author: '91浏览器技术团队',
    date: '2026-06-20',
    readTime: '3分钟',
    tags: ['翻译', '多语言', '技巧', '国际化'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20language%20translation%20visual%20with%20flowing%20bilingual%20text%20elements%20and%20glowing%20connection%20lines%2C%20global%20communication%20concept%2C%20minimalist%20design%20with%20warm%20teal%20and%20coral%20accents&width=600&height=400&seq=article-10&orientation=landscape',
  },
  {
    id: '11',
    title: '91浏览器密码管理与安全建议',
    slug: 'password-management-security',
    category: '隐私安全',
    categorySlug: 'privacy-security',
    excerpt: '91浏览器内置密码管理器可以帮助您安全存储和自动填充账号密码。本文介绍密码管理器的使用方法和账号安全最佳实践。',
    content: `<h2>密码管理器简介</h2><p>91浏览器内置的密码管理器采用AES-256加密算法，安全存储您的网站账号和密码，支持自动填充和一键登录。</p><h2>如何保存密码</h2><p>首次在某网站登录时，91浏览器会询问是否保存密码。点击"保存"后，下次访问该网站时将自动填充账号信息。</p><h2>查看和管理密码</h2><p>进入设置 → 隐私 → 密码管理，可以查看、编辑或删除已保存的密码。所有密码均需通过指纹或面部识别验证后才能查看。</p><h2>安全建议</h2><p>1. 为不同网站使用不同的密码；</p><p>2. 定期更换重要账号的密码；</p><p>3. 开启双重验证增加安全性；</p><p>4. 不要在公共设备上保存密码。</p>`,
    author: '91浏览器安全团队',
    date: '2026-06-15',
    readTime: '5分钟',
    tags: ['密码', '安全', '账号', '加密'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20digital%20lock%20and%20key%20concept%20with%20flowing%20encrypted%20data%20streams%2C%20password%20security%20visual%2C%20modern%20cybersecurity%20design%2C%20warm%20neutral%20background%20with%20subtle%20gradient&width=600&height=400&seq=article-11&orientation=landscape',
  },
  {
    id: '12',
    title: '91浏览器v8.1版本即将发布：AI智能助手来了',
    slug: 'version-8-1-preview-ai-assistant',
    category: '版本更新',
    categorySlug: 'version-updates',
    excerpt: '91浏览器v8.1版本预告：即将推出AI智能助手功能，支持智能搜索摘要、网页内容总结、智能翻译增强等全新AI功能。',
    content: `<h2>v8.1版本前瞻</h2><p>91浏览器团队正在全力开发v8.1版本，本次更新将重点引入AI功能，全面升级浏览体验。</p><h2>AI智能助手</h2><p>全新AI助手将集成在浏览器中，支持以下功能：智能搜索摘要——自动提炼搜索结果关键信息；网页内容总结——一键生成长文章摘要；智能翻译增强——结合上下文进行更精准的翻译。</p><h2>预计发布时间</h2><p>v8.1版本预计将于2026年9月初正式发布，届时将通过应用商店推送更新。</p>`,
    author: '91浏览器开发团队',
    date: '2026-06-10',
    readTime: '2分钟',
    tags: ['版本更新', 'v8.1', 'AI', '智能助手'],
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20assistant%20concept%20with%20glowing%20neural%20network%20patterns%20and%20a%20smartphone%20silhouette%2C%20artificial%20intelligence%20technology%20visual%2C%20warm%20coral%20and%20teal%20gradient%2C%20clean%20modern%20composition&width=600&height=400&seq=article-12&orientation=landscape',
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(categorySlug: string): Article[] {
  if (categorySlug === 'all') return articles;
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getRelatedArticles(article: Article, count: number = 3): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
}